// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w93K","content":"styles_content__aeyuu","tableWrap":"styles_tableWrap__1nao3"};